var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAnnotationPreference = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 45,
  height: 45,
  fill: "none",
  viewBox: "0 0 45 45",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.813,
  d: "M8.438 2.813h28.124a5.613 5.613 0 0 1 5.626 5.624v28.126a5.613 5.613 0 0 1-5.626 5.624H8.439a5.613 5.613 0 0 1-5.626-5.624V8.436a5.613 5.613 0 0 1 5.626-5.624M11.25 11.25h2.813"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.813,
  d: "M16.875 14.063a2.812 2.812 0 1 1 0-5.625 2.812 2.812 0 0 1 0 5.624M19.688 11.25H33.75M33.75 22.5h-2.812M28.125 25.313a2.812 2.812 0 1 0 0-5.625 2.812 2.812 0 0 0 0 5.625M25.313 22.5H11.25M11.25 33.75h2.813M16.875 36.563a2.812 2.812 0 1 1 0-5.625 2.812 2.812 0 0 1 0 5.625M19.688 33.75H33.75"
})));
export { SvgAnnotationPreference as ReactComponent };
export default __webpack_public_path__ + "assets/images/annotation-preference.svg";